import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AlertService } from '../vqutils/vq-alert/vq-alert.component';
import { BodyClassService } from '../vqutils/body-class.service';
import { ModalService } from '../vqutils/vq-modal/vq-modal.component';
import { ApiService } from '../services/api.service';
import { LocalStorageService } from '../services/localstorage.service';

@Component({
  selector: 'app-space-step-4',
  templateUrl: './space-step-4.component.html',
  styles: []
})
export class SpaceStep4Component implements OnInit {

	space: any = {};
  files: any = {};
  errors:any = {};
  constructor(
    private route: ActivatedRoute,
    private _router: Router,
    private _as:AlertService,
    private _bc : BodyClassService,
    private _localStorage : LocalStorageService,
    private _ms: ModalService,
    private _api: ApiService,
  ) { }

  ngOnInit() {
    // this._as.success('Vous ne pouvez définir qu\'un seul chef de projet');
    this.route.params.subscribe(
      params => {
        if(params['id']){
          this.space.id = params['id'];
          this._api.spaces
          .retrieve(this.space.id)
          .subscribe(
            (data) => {
              this.space = data;
            },
            (errors) => {
            })
        }
      })
  }

  private _deleteFile(file){
    const formData = new FormData();
    formData.append(file, '');
    this._api.spaces
      .partialUpdate(this.space.id, formData, {}, true)
      .subscribe(
        (data) => {
          this.space = data;
          this.files[file]= '';
          this._as.success('Votre planning a été supprimé');
        },
        (errors) => {
          this.errors = errors;
          this._as.danger('Une erreur empêche la suppression du planning');
        })
  }

  deleteFile(file){
    this._ms.delete({
      confirm: () => this._deleteFile(file)
    })
  }

  fileChange(event, field) {
    this.files[field] = event.srcElement.files[0];
    if(this.space.id){
      const formData = new FormData();
      if(this.files.global_term){
        formData.append('global_term', this.files.global_term);
      }
      if(this.files.short_term){
        formData.append('short_term', this.files.short_term);
      }
      this._api.spaces
      .partialUpdate(this.space.id, formData, {}, true)
      .subscribe(
        (data) => {
          this.space = data;
          this.files[field]= '';
          this._as.success('Votre planning ont été ajouté');
        },
        (errors) => {
          this.errors = errors;
          this._as.danger('Une erreur empêche l\'ajout du planning');
        })
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/space-step-4/space-step-4.component.ts